import React, { useState } from 'react';

export default function TimelineEditor({ updates = [], onSave, onClose }) {
  const [items, setItems] = useState(
    updates.map(u => ({ ...u })).sort((a, b) => new Date(b.date) - new Date(a.date))
  );

  const addItem = () => setItems([{ date: new Date().toISOString().split('T')[0], text: '', source: '' }, ...items]);

  const updateItem = (idx, field, value) => {
    const updated = [...items];
    updated[idx] = { ...updated[idx], [field]: value };
    setItems(updated);
  };

  const removeItem = (idx) => setItems(items.filter((_, i) => i !== idx));

  const handleSave = () => {
    const cleaned = items.filter(u => u.text.trim());
    onSave(cleaned);
    onClose();
  };

  return (
    <div className="admin-modal-backdrop" onClick={onClose}>
      <div className="admin-modal admin-modal-wide" onClick={e => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>Edit Timeline</h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">
          {items.map((item, idx) => (
            <div key={idx} className="admin-timeline-row">
              <input
                type="date"
                value={item.date || ''}
                onChange={e => updateItem(idx, 'date', e.target.value)}
                className="admin-input admin-input-date"
              />
              <textarea
                placeholder="What happened..."
                value={item.text}
                onChange={e => updateItem(idx, 'text', e.target.value)}
                className="admin-input admin-input-text"
                rows={2}
              />
              <input
                type="url"
                placeholder="Source URL (optional)"
                value={item.source || ''}
                onChange={e => updateItem(idx, 'source', e.target.value)}
                className="admin-input"
              />
              <button className="admin-btn-remove" onClick={() => removeItem(idx)} title="Remove">×</button>
            </div>
          ))}
          <button className="admin-btn-add" onClick={addItem}>+ Add update</button>
        </div>
        <div className="admin-modal-footer">
          <button className="admin-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="admin-btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}